export default __webpack_public_path__ + "static/media/logo.fff5a98b.svg";